export type ShowcaseVideo = {
  templateId?: string
  duration?: number
  categories?: string[]
  id?: string
  label: string
  poster: string
  title: string
  url: string
}

export const productShowcaseVideos = [
  {
    id: "source",
    label: "原视频",
    title: "爆款参考",
    url: "https://cdn-testing.duobaogongxiao.com/kada-uploads/1785120138191-z18mowtj-______.mp4",
    poster:
      "https://cdn-testing.duobaogongxiao.com/kada-uploads/1785821391302-0p7udhlb-20260804-124018.jpg",
  },
  {
    id: "recreated",
    label: "复刻视频",
    title: "AI 复刻成片",
    url: "https://cdn-testing.duobaogongxiao.com/kada-uploads/1785120166603-t4hlkfrl-_______.mp4",
    poster:
      "https://cdn-testing.duobaogongxiao.com/kada-uploads/1785821391158-titq2vy3-20260804-124014.jpg",
  },
] as const satisfies readonly ShowcaseVideo[]

export const toShowcaseVideo = (
  template: import("~/common/videoTemplate/types").VideoTemplate,
): ShowcaseVideo => ({
  templateId: template.templateId,
  title: template.title,
  duration: template.duration,
  categories: template.categories,
  label: template.keywords[0] || "视频模板",
  poster: template.videoCover,
  url: template.videoUrl,
})
